export const getBrandHostname = (state: any) =>
  state.page?.data?.site?.domain?.brand;
